(() => {
  const root = document.querySelector('.ms-advertorial');
  if (!root) return;

  function trackClarityEvent(eventName) {
    if (eventName && typeof window.clarity === 'function') {
      window.clarity('event', eventName);
    }
  }

  trackClarityEvent('advertorial_view');

  const slider = root.querySelector('.face-proof-slider');
  if (slider) {
    const slides = Array.from(slider.querySelectorAll('.face-proof-slide'));
    if (slides.length > 1) {
      let currentSlide = 0;
      window.setInterval(() => {
        slides[currentSlide].classList.remove('is-active');
        currentSlide = (currentSlide + 1) % slides.length;
        slides[currentSlide].classList.add('is-active');
      }, 2600);
    }
  }

  function bindScroller(trackSelector, controlSelector, dirAttribute) {
    const track = root.querySelector(trackSelector);
    const controls = Array.from(root.querySelectorAll(controlSelector));
    if (!track || !controls.length) return;

    controls.forEach((button) => {
      button.addEventListener('click', () => {
        const direction = Number(button.getAttribute(dirAttribute)) || 1;
        const card = track.children[0];
        const step = trackSelector === '.organic-strip'
          ? track.clientWidth * 0.72
          : (card ? card.getBoundingClientRect().width + 16 : track.clientWidth);
        track.scrollBy({ left: direction * step, behavior: 'smooth' });
      });
    });
  }

  bindScroller('.organic-strip', '[data-proof-dir]', 'data-proof-dir');

  const reviewCarousel = root.querySelector('.review-carousel');
  const reviewTrack = root.querySelector('.review-track');
  const reviewMore = root.querySelector('[data-review-more]');
  if (reviewCarousel && reviewTrack && reviewMore) {
    const reviewCards = Array.from(reviewTrack.querySelectorAll('.review-card'));
    const initialVisibleReviews = window.matchMedia('(min-width: 900px)').matches ? 6 : 3;
    let visibleReviews = initialVisibleReviews;

    function updateReviews() {
      reviewCards.forEach((card, index) => {
        card.classList.toggle('is-hidden', index >= visibleReviews);
      });

      const allVisible = visibleReviews >= reviewCards.length;
      reviewCarousel.classList.toggle('has-more', !allVisible);
      reviewMore.textContent = allVisible ? 'Show fewer reviews' : 'Show more reviews';
    }

    reviewMore.addEventListener('click', () => {
      if (visibleReviews >= reviewCards.length) {
        visibleReviews = initialVisibleReviews;
        reviewCarousel.classList.remove('is-stepped');
        updateReviews();
        reviewCarousel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      visibleReviews = Math.min(visibleReviews + 3, reviewCards.length);
      reviewCarousel.classList.add('is-stepped');
      updateReviews();
    });

    updateReviews();
  }

  const defaultAttribution = {
    utm_source: 'advertorial',
    utm_medium: 'shopify_page',
    utm_campaign: 'structure_report',
  };

  const passthroughParams = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_id',
    'gclid',
    'gbraid',
    'wbraid',
    'fbclid',
    'ttclid',
    'msclkid',
  ];

  const currentParams = new URLSearchParams(window.location.search);
  const attribution = { ...defaultAttribution };
  passthroughParams.forEach((name) => {
    const value = currentParams.get(name);
    if (value) attribution[name] = value;
  });

  root.querySelectorAll('[data-ms-cta]').forEach((link) => {
    const ctaName = link.getAttribute('data-ms-cta');
    try {
      const url = new URL(link.href, window.location.origin);
      Object.entries(attribution).forEach(([name, value]) => {
        url.searchParams.set(name, value);
      });
      if (ctaName) {
        url.searchParams.set('utm_content', ctaName);
      }
      link.href = url.toString();
    } catch (error) {
      // Keep the original link if the browser cannot parse it.
    }

    link.addEventListener('click', () => {
      const eventName = link.getAttribute('data-ms-cta');
      trackClarityEvent(eventName);
    });
  });
})();
